export function format(first: string, middle: string, last: string): string {
  return (first || '') + (middle ? ` ${middle}` : '') + (last ? ` ${last}` : '');
}

export function track(event: UIEvent): string {
  const eventTarget = event.target as HTMLElement;
  const eventCurrentTarget = event.currentTarget as HTMLElement;
  let timeout = 0;

  const pushDataLayer = dataLayerObject => {
    window.dataLayer.push(dataLayerObject);
    // localStorage.setItem('dataLayerObject','true') to show console logs
    if (localStorage.getItem('dataLayerObject') === 'true') console.log('###', 'new push =>', 'dataLayerObject', dataLayerObject);
    if (localStorage.getItem('dataLayerObject') === 'true') console.table(dataLayerObject);
    if (localStorage.getItem('dataLayerObject') === 'true') console.log(JSON.stringify(dataLayerObject, null, 2));
  };

  const trackingStyle = eventTarget.closest('[data-tracking-style]') ? (eventTarget.closest('[data-tracking-style]') as HTMLElement).dataset.trackingStyle : 'no-style';
  const trackingContext = eventTarget.closest('[data-tracking-context]') ? (eventTarget.closest('[data-tracking-context]') as HTMLElement).dataset.trackingContext : 'no-context';
  const trackingParentId = eventTarget.closest('[data-tracking-id]') ? (eventTarget.closest('[data-tracking-id]') as HTMLElement).dataset.trackingId : 'no-id';
  const trackingArea = eventTarget.closest('[data-tracking-area]') ? (eventTarget.closest('[data-tracking-area]') as HTMLElement).dataset.trackingArea : 'no-area';
  const trackingSource = eventTarget.closest('[data-tracking-source]') ? (eventTarget.closest('[data-tracking-source]') as HTMLElement).dataset.trackingSource : false;
  const trackingValue = eventTarget.closest('[data-tracking-value]') ? (eventTarget.closest('[data-tracking-value]') as HTMLElement).dataset.trackingValue : '';
  // Special Tracking param for special states or calculations
  const trackingExtra = eventTarget.closest('[data-tracking-extra]') ? (eventTarget.closest('[data-tracking-extra]') as HTMLElement).dataset.trackingExtra : '';
  let destinationUrl = eventTarget.closest('[href]') ? (eventTarget.closest('[href]') as HTMLElement).getAttribute('href') : 'no-destination-url';
  let trackingTopic = eventTarget.closest('[data-tracking-topic]') ? (eventTarget.closest('[data-tracking-topic]') as HTMLElement).dataset.trackingTopic : 'no-topic';

  if (destinationUrl !== '' && destinationUrl !== 'no-destination-url') {
    destinationUrl = new URL(destinationUrl, location.origin).toString();
  } else {
    destinationUrl = 'no-destination-url';
  }

  if (trackingTopic === 'rte-link') {
    trackingTopic = eventTarget.innerText;
  }

  const dataLayerObject = {
    event: 'component',
    componentStyle: trackingStyle,
    componentContext: trackingContext,
    componentTopic: trackingTopic,
    componentActionArea: trackingArea,
    componentParentComponentId: trackingParentId,
    componentDestinationURL: destinationUrl,
    componentValue: trackingValue,
  };

  if (trackingSource) {
    dataLayerObject['componentTrackingSource'] = true;
  }

  // first special open/closed state tracking for accordion item clicks. else param just won't exist in tracking object
  if (trackingExtra == 'accordion') {
    timeout = 100;
    setTimeout(() => {
      dataLayerObject['componentIsOpened'] =
        eventCurrentTarget.closest('bal-list-item').classList.contains('bal-list__item--expanding') ||
        eventCurrentTarget.closest('bal-list-item').classList.contains('bal-list__item--expanded')
          ? 'true'
          : 'false';
    }, 50);
  }

  if (typeof window.dataLayer != 'undefined') {
    if (timeout) {
      setTimeout(() => {
        pushDataLayer(dataLayerObject);
      }, timeout);
    } else {
      pushDataLayer(dataLayerObject);
    }
  }
  return '';
}

export function replaceImageSrcPlaceholder(text: string | null | undefined): string {
  if (!text) {
    return "";
  }
  return text.replace(new RegExp(";", "g"), ',');
}
